import {HOME} from '../actions';

const initialState = {  
	data:[],	
	totalUserData:[],      
	selectedRows: [],  
	selectedRowKeys: [],
	searchProps:{},
	sortProps:[['id','desc']],
	detailDivVisible: false,
	pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 10,
		  pageSize:10,
		  current: 1,
		  total:0,
		},
	loading:false,
	tableSize:'middle',
	showDrawer:false,
	showSearchForm:false,
	collapse:false,	
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case HOME: {		
	
      return {
        ...state,
        ...action.payload
      }
    }


    default:
      return state;
  }
}